import React from 'react'
import { If } from 'react-extras'

import { Row } from 'antd'

import CustomInput from '../../components/CustomInput/customInput'

const ConfigurationRow = ({ values, errors, handleBlur, setFieldValueWithState, period }) => {
  return (
    <Row type="flex" justify="start">
      <CustomInput
        type="text"
        field="organizationName"
        errors={errors}
        setFieldValue={setFieldValueWithState}
        rowSpan={4}
        value={values}
        handleBlur={handleBlur}
        disabled
      />
      <If condition={period === 'walletEdition'}>
        <CustomInput
          type="date"
          field="clientEditionPeriodStartDate"
          errors={errors}
          setFieldValue={setFieldValueWithState}
          rowSpan={6}
          value={values}
          format="DD/MM/YYYY"
          handleBlur={handleBlur}
          required
        />
        <CustomInput
          type="date"
          field="clientEditionPeriodEndDate"
          errors={errors}
          setFieldValue={setFieldValueWithState}
          rowSpan={6}
          value={values}
          format="DD/MM/YYYY"
          handleBlur={handleBlur}
          required
        />
        <CustomInput
          type="number"
          field="clientQuantity"
          errors={errors}
          setFieldValue={setFieldValueWithState}
          rowSpan={4}
          value={values}
          handleBlur={handleBlur}
          required
        />
      </If>
      <If condition={period === 'actionPlanning'}>
        <CustomInput
          type="date"
          field="actionPlanningPeriodStartDate"
          errors={errors}
          setFieldValue={setFieldValueWithState}
          rowSpan={6}
          value={values}
          format="DD/MM/YYYY"
          handleBlur={handleBlur}
          required
        />
        <CustomInput
          type="date"
          field="actionPlanningPeriodEndDate"
          errors={errors}
          setFieldValue={setFieldValueWithState}
          rowSpan={6}
          value={values}
          format="DD/MM/YYYY"
          handleBlur={handleBlur}
          required
        />
      </If>
      <If condition={period === 'actionExecution'}>
        <CustomInput
          type="date"
          field="actionExecutionPeriodStartDate"
          errors={errors}
          setFieldValue={setFieldValueWithState}
          rowSpan={6}
          value={values}
          format="DD/MM/YYYY"
          handleBlur={handleBlur}
          required
        />
        <CustomInput
          type="date"
          field="actionExecutionPeriodEndDate"
          errors={errors}
          setFieldValue={setFieldValueWithState}
          rowSpan={6}
          value={values}
          format="DD/MM/YYYY"
          handleBlur={handleBlur}
          required
        />
      </If>
    </Row>
  )
}

export default ConfigurationRow
